import { useCallback, useState } from 'react';

export function useControlledValue<T>(value: T | undefined, setter: ((value: T) => void) | undefined, defaultValue: T) {
  const [internalValue, setInternalValue] = useState<T>(value ?? defaultValue);
  const handleSetValue = useCallback(
    (value: T) => {
      setInternalValue(value);
      setter?.(value);
    },
    [setter],
  );

  if (setter) {
    return [value ?? internalValue, handleSetValue] as const;
  }

  return [internalValue, handleSetValue] as const;
}
